import { Outlet } from "react-router-dom";
import MiniDrawer from "../../../pages/dashboard/component";

const Layout = () => {
  return (
    <>
      <MiniDrawer></MiniDrawer>
      <Outlet />
    </>
  );
};

export default Layout;
